import { saveAs } from 'file-saver'
import I18n from 'i18n-js'
import callApi from 'services'
import { errorToast } from 'utils/toast'
import { filtersToUrlParams } from './index'

export default {
  getPatrimonyList(params) {
    return callApi(`patrimonies?${params ? filtersToUrlParams(params) : ''}`, 'GET')
  },
  importCsvPatrimonies(csv, params, isDryRun) {
    const queryParams = { ...params, ...(isDryRun ? { isDryRun: true } : {}) }
    const formData = new FormData()
    formData.append('file', csv)
    return callApi(`import/patrimonies/files?${filtersToUrlParams(queryParams)}`, 'POST', formData, undefined, true)
  },
  createPatrimony(patrimony) {
    return callApi(`patrimonies`, 'POST', JSON.stringify(patrimony))
  },
  updatePatrimony(patrimony) {
    return callApi(`patrimonies/${patrimony.id}`, 'PUT', JSON.stringify(patrimony))
  },
  deletePatrimony(patrimony) {
    return callApi(`patrimonies/${patrimony.id}`, 'DELETE')
  },
  createSector(sector) {
    return callApi(`sectors`, 'POST', JSON.stringify(sector))
  },
  updateSector(sector) {
    return callApi(`sectors/${sector.id}`, 'PUT', JSON.stringify(sector))
  },
  deleteSector(sector) {
    return callApi(`sectors/${sector.id}`, 'DELETE')
  },
  createAgency(agency) {
    return callApi(`agencies`, 'POST', JSON.stringify(agency))
  },
  updateAgency(agency) {
    return callApi(`agencies/${agency.id}`, 'PUT', JSON.stringify(agency))
  },
  deleteAgency(agency) {
    return callApi(`agencies/${agency.id}`, 'DELETE')
  },
  exportPatrimony() {
    return callApi(`patrimonies/export`, 'GET')
      .then(async (response) => {
        saveAs(await response.blob(), response.headers.get('Content-Disposition').split('filename=')[1])
      })
      .catch(() => {
        errorToast(I18n.t('ErrorExport'))
      })
  },

  getSectorsByPatrimonyId(patrimonyId) {
    return callApi(`patrimonies/${patrimonyId}/sectors`, 'GET')
  },

  getAgenciesBySectorId(sectorId) {
    return callApi(`patrimonies/sectors/${sectorId}/agencies`, 'GET')
  },
}
